module.exports = __webpack_public_path__ + "static/media/08-stenio-rocha.90d8dc7c.webp";